<template>
    <div class="point-records">
        <div class="search">
            <div class="left">
                <xl-select
                    class="select-width"
                    :placeholder="$t('design.pointRecords.cardType') || '卡类型'"
                    v-model="searchParam.cardType"
                    :options="cardList"
                    size="large"
                    clearable
                    @change="search"
                    >
                </xl-select>
                <!-- <xl-select
                    class="select-width"
                    placeholder="状态"
                    v-model="searchParam.payType"
                    :options="payTypeList"
                    size="large"
                    clearable
                    @change="search"
                    >
                </xl-select> -->
                <xl-input
                    class="input-width"
                    :placeholder="$t('design.pointRecords.cardNo') || '支付卡号'"
                    v-model="searchParam.cardNo"
                    size="large"
                    @keydown.enter="search"
                    >
                    <template #suffix>
                        <SearchBlod @click="search"></SearchBlod>
                    </template>
                </xl-input>
                <xl-divider class="" direction="vertical" />
                <xl-button class="button-width" size="large" @click="handleReset">
                    <xl-icon name="zhongzhishitu1"></xl-icon>
                    <span>{{$t('design.reset') || '重置'}}</span>
                </xl-button>
            </div>
        </div>
        <div class="table" ref="containerRef">
            <xl-table :data="tableData" :headers="headers" height="100%" :emptyText="$t('design.noData')">
                <xl-table-column
                    prop="cardType"
                    align="left"
                    minWidth='120'
                    :label="$t('design.pointRecords.cardType') || '卡类型'"
                    >
                    <template #default="{ row }">
                        <span>{{ payBrandMap[row?.cardType] || "-" }}</span>
                    </template>
                </xl-table-column>
                <xl-table-column
                    prop="cardNo"
                    align="left"
                    :label="$t('design.pointRecords.cardNumber') || '卡号'"
                    show-overflow-tooltip
                    minWidth='180'
                    >
                    <template #default="{ row }">
                        <span>{{ row?.cardNo || "-" }}</span>
                    </template>
                </xl-table-column>
                <xl-table-column
                    prop="cardPoint"
                    align="left"
                    :label="$t('design.pointRecords.cardPoint') || '面值(point)'"
                    minWidth='150'
                    >
                    <template #default="{ row }">
                        <span>{{ row?.cardPoint || "0" }}</span>
                    </template>
                </xl-table-column>
                <xl-table-column
                    prop="leftPoint"
                    align="left"
                    :label="$t('design.pointRecords.leftPoint') || '余额(point)'"
                    minWidth='150'
                    >
                    <template #default="{ row }">
                        <span>{{ row?.leftPoint || "0" }}</span>
                    </template>
                </xl-table-column>
                <xl-table-column
                    prop="expiredOn"
                    align="left"
                    :label="$t('design.pointRecords.expiredOn') || '有效期至'"
                    minWidth='180'
                    >
                    <template #default="{ row }">
                        <span>{{ row?.expiredOn ? $convertUTCDateToLocalDate(row?.expiredOn) : "-" }}</span>
                    </template>
                </xl-table-column>
                <xl-table-column
                    prop="cardActive"
                    align="left"
                    :label="$t('design.status') || '状态'"
                    minWidth='140'
                    >
                    <template #default="{ row }">
                        <span><xl-tag :type="statusMap[row.cardActive]?.type">{{ statusMap[row?.cardActive]?.title || "-" }}</xl-tag></span>
                    </template>
                </xl-table-column>
                <xl-table-column
                    align="left"
                    :label="$t('design.operate') || '操作'"
                    minWidth='105'
                    fixed="right"
                    >
                    <template #default="{ row }">
                        <xl-tooltip
                            effect="dark"
                            :content="$t('design.pointRecords.goDetail') || '支付详情'"
                            placement="top"
                            :show-after="200"
                        >
                            <xl-icon class="operate-icon view-icon" size="20" @click="handleDetail(row.cardNo)"><Kejian /></xl-icon>
                        </xl-tooltip>
                    </template>
                </xl-table-column>
            </xl-table>
        </div>
        <xl-pagination
            v-model:page="pageInfo.page"
            v-model:pageSize="pageInfo.pageSize"
            :total="pageInfo.total"
            @pageSizeChange="getList"
            @pageChange="getList"
        >
        </xl-pagination>
    </div>
</template>

<script setup>
import {
    XlButton,
    XlTable,
    XlTableColumn,
    XlDivider,
    XlSelect,
    XlMessageBox,
    XlPagination,
    XlTag,
    XlFormItem,
    XlForm,
    XlInput,
    XlDatePicker,
    XlIcon,
    XlMessage,
    XlLoading,
    XlTooltip
} from "@shining3d/ui-components";
import { ref, reactive, computed, onMounted, defineEmits, defineProps } from "vue";
import { Kejian, SearchBlod } from "@shining3d/icons-vue";
import _get from 'lodash/get';
import { cloneDeep } from "lodash";
import { useStore } from "vuex";
import router from "@/router";
import { useLang } from '@shining3d/common-module/utils/lang.js';
import { $convertUTCDateToLocalDate, $convertLocalDateToUTCDate, formatPrice } from '../../utils/common.js';
import { cardList } from '../../common/enum.js';
import creditCardApi from "../../api/creditCard";
const route = router.currentRoute.value;
const $store = useStore();
const { $t } = useLang( '@shining3d/xl-design-order' );

const props = defineProps({
    platform: {
        type: String
    }
});

const emits = defineEmits(['pointDetail']);

const payBrandMap = cardList.reduce((obj, cur) => {
  obj[cur.value] = cur.label;
  return obj;
}, {});

const statusMap = {
    'active': {
        type: 'success',
        title: $t('design.pointRecords.active') || '生效中'
    },
    'expired': {
        type: 'info',
        title: $t('design.creditCard.expiredTip') || '已过期'
    },
    'complete': {
        type: 'info',
        title: $t('design.pointRecords.complete') || '已完结'
    },
    'expiredSoon': {
        type: 'warning',
        title: $t('design.pointRecords.expiredSoon') || '即将过期'
    }
}
const pageInfo = ref({
    page: 1,
    pageSize: 20,
    total: 0,
    pages: 0
});

const initSearchParam = {
    cardNo: "", // 支付卡号
    cardType: "", // 卡类型
};

// 机构id
const institutionId = computed(() => {
    let id = _get( $store, 'state.factorySelect.id', '');
    if ( props.platform === 'designerService') {
        id = _get( $store, 'state.factoryID', '');
    }
    return id;
});

const searchParam = ref(cloneDeep(initSearchParam));

const headers = ref([]);
const tableData = ref([]);

const changeUrl = () => {
    const query = _get( router, 'currentRoute.value.query', {});
    const params = _get( router, 'currentRoute.value.params', {});

    const newQuery = JSON.parse(JSON.stringify(query));
    // 去除站内信跳转过来 url的参数cardNo
    delete newQuery.cardNo;
    router.replace({ params: { ...params }, query: { ...newQuery }}); 
};

const handleReset = () => {
    searchParam.value = cloneDeep(initSearchParam);
    pageInfo.value.page = 1;
    changeUrl();
    getList();
};

const search = () => {  
    changeUrl();
    getList();
};

const containerRef = ref(null);
const loadingInstance = ref(null);
const getList = () => {
    if ( loadingInstance.value ) {
		loadingInstance.value?.close();
	}
	loadingInstance.value = XlLoading.service({
		target: containerRef.value,
		background: 'rgba(255,255,255,0.9)',
	});
    creditCardApi.factoryPointCardList({
        ...searchParam.value,
        pageSize: pageInfo.value.pageSize,
        page: pageInfo.value.page,
        factoryID: institutionId.value,
    }).then((res) => {
        if( res && res.status === 'success' ){
            tableData.value = res.result || [];
            pageInfo.value = res.pageInfo || {};
        }
        loadingInstance.value?.close();
    }).catch((e) => {
        console.log(e);
        loadingInstance.value?.close();
    })
};

// 跳转支付记录页面，搜索该卡的支付记录
const handleDetail = ( id ) => {
    emits('pointDetail', id);
};

onMounted(() => {
    const query = _get( router, 'currentRoute.value.query', {});
    if ( query.cardNo ) {
        searchParam.value.cardNo = query.cardNo;
    }
    getList();
});

</script>

<style lang="scss" scoped>
.point-records {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;
    height: 100%;
    .search {
        flex-grow: 0;
        flex-shrink: 0;
        margin-top: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        box-sizing: border-box;
        .margin8 {
            margin-left: 8px;
        }
        .left {
            display: flex;
            align-items: center;
            margin: -8px 8px 0 -8px;
            & > * {
                margin: 8px 0 0 8px;
            }
            .input-width {
                max-width: 200px;
            }
            .select-width {
                max-width: 160px;
            }
            :deep(.xl-date-picker.el-date-editor) {
                width: 330px;
                margin-left: 8px;
                margin-top: 8px;
            }
            :deep(.el-date-editor .el-range-separator){
                flex: 0;
            }
        }
        .right {
            flex-grow: 0;
            flex-shrink: 0;
        }
        .button-width {
            width: 88px;
            padding: 0 !important;
            .xl-icon {
                margin-right: 4px;
            }
            &:hover{
                .xl-icon {
                color: #5587FF !important;
                background: #ffffff !important;
                }
            }
        }
        .export-width{
                width: 94px !important;
        }
        :deep(.el-divider) {
            height: 20px;
            color: #e0e4ea;
        }
    }
    .table {
        width: 100%;
        height: calc(100% - 200px);
        margin: 16px 0 7px;
        box-sizing: border-box;
        overflow: auto;
        flex-grow: 1;
        position: relative;
        :deep(.xl-table) {
            flex-grow: 1;
        }
        .submitted {
            padding-left: 18px;
            position: relative;
            &::before {
                content: "";
                position: absolute;
                top: 50%;
                left: 1px;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                margin-top: -4px;
                background-color: #0fbd81;
            }
            &.submitted-not::before {
                background-color: #a5acbe;
            }
        }
    }
    :deep(.xl-pagination) {
        // margin-right: 16px;
        flex-grow: 0;
        flex-shrink: 0;
    }
    .operate {
        cursor: pointer;
        width: 28px;
        height: 28px;
        line-height: 28px;
        font-size: 20px;
        text-align: center;
        border-radius: 6px;
        display: inline-block;
        &:not(:first-of-type) {
        margin-left: 8px;
        }
    }
    .edit-icon {
        margin-left: 8px;
        display: inline-block;
        height: 28px;
        line-height: 28px;
    }
    .disabled-edit {
        opacity: 0.4;
        cursor: not-allowed;
        .iconfont {
        pointer-events: none;
        }
    }
    :deep(.xl-table.el-table .xl-table-empty) {
        min-height: 0 !important;
    }
    .xl-pagination{
        position: relative;
    }
    :deep(.el-scrollbar__view){
        height: 100%;
    }
}
</style>